var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-no-data"},[_c('div',{staticClass:"list-no-data__icon"}),_vm._v(" "),_c('div',{staticClass:"list-no-data__text",style:({width: _vm.textLength})},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }